export default __webpack_public_path__ + "static/TeamArturKisiolek-2e7ea17a23fa07360b161a7155840fc5.png";